<script setup>
import {ref, onMounted} from "vue";
import {ElDialog} from 'element-plus'
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Recharge from "@/components/recharge.vue";
// 登录/注册已改为独立页面（/login、/register），这里只保留用户信息展示和充值弹窗
const store = useStore()
const router = useRouter()
let dialogMoney = ref(false)
let hh = ref(null)

const clear = () => {
  localStorage.removeItem('userInfo')
  store.userinfo = {}
  store.commit('setUserInfo', {})
  // 退出后强制回登录页
  router.push('/login')
}
// 首页只有登录后才能进来，有本地登录信息才校验 token
if (localStorage.getItem('userInfo')) {
  store.dispatch('updateUserInfoStatus')
}
onMounted(() => {
  if (localStorage.getItem('userInfo')) {
    store.commit('setUserInfo', JSON.parse(localStorage.getItem('userInfo')))
  }
})
</script>

<template>
  <div class="user-box" ref="hh">
    <div id="contact-form" class="u-box">
      <span @click="router.push('/login')" style="cursor: pointer;color: white" v-if="!store.state.userinfo.username" >亲，您尚未登录，<span data-v-2fb5d6b3="" style="color: yellow; cursor: pointer; text-decoration: underline;">点击登录/注册账户，即可兑换 &gt;</span> </span>
      <template  v-else >
      <img src="@/assets/coin.png" style="width: 45px;margin-right: 5px" alt="">
      <span>欢迎您，{{store.state.userinfo.username}} </span>
      <span style="margin-left: 10px; color: yellow;">您的邀请码：</span>
      <span v-if="store.state.userinfo.invite_status" style="color: yellow;text-decoration: underline;">{{store.state.userinfo.invite_code}}</span>
      <span v-else style="color: yellow;text-decoration: underline;">暂未开启</span>
      <span style="margin-left: 10px" >兑换币余额：{{store.state.userinfo.score}}</span>
      <span  style="cursor: pointer;color: red;margin-left: 20px;text-decoration: underline;" @click="dialogMoney=true">兑换币充值</span>
      <span style="color: yellow;cursor: pointer;text-decoration: underline;margin-left: 20px;" @click="clear">退出账户</span>
</template>
    </div>

  </div>
  <el-dialog
      v-model="dialogMoney"

      :show-close="false"
      width="688"
  >
    <template #default>
      <Recharge v-if="dialogMoney" @close="dialogMoney=false"></Recharge>
    </template>
  </el-dialog>
</template>

<style lang="less" scoped>
.header-box {
  display: flex;
  width: 100%;
  height: 10vh;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  font-size: 19.2px;
  font-weight: bold;

  img {
    width: 40px;
    margin-right: 10px;
  }

  .left {
    display: flex;
    align-items: center;
  }

  .right {
    color: blue;
    font-size: 15px;
    font-weight: normal;
    cursor: pointer;
    text-underline: blue;

    span {
      margin-left: 5px;
    }
  }
}

.user-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: white;
  margin-top: 30px;
  img{
    transform: translateY(-10px);
  }
  .u-box{
    height: 40px;
    width: 770px;
    display: flex;
    background: #66b1ff;
    border-radius: 10px;
    align-items: center;
    padding-left: 20px;
    font-size: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    font-weight: bold;
  }
}

</style>